import { DonationCategory } from "../Payment/constant";

export const monthlyRadharani = [
"Once Saint Durvasa blessed Srimati Radharani (the eternal consort of Krishna) as follows, “Radha, may the grains You cook taste sweeter than nectar and may anyone you eats them be blessed with a long life span”. Thus, Mother Yasoda, Krishna’s mother, invited Srimati Radharani to cook for Krishna as this would nourish Him physically with good health and spiritually with the transcendental love of His devotee, Srimati Radharani.",

"Krishna is most pleased when He honours foodstuff prepared by Srimati Radharani and every kitchen where foodstuffs are cooked for the Deities is a representation of the kitchen of Radharani.",
"Any food items you offer under Radharani’s Kitchen seva, will utilised in the Deity kitchen to prepare various food offerings to the Deities.",

"You can make a donation for a month’s seva. Your contribution will directly support the preparation of food for the Deities during that month."
];

export const options = [
  {
    value: "option1",
    label: "Deity Seva",
    columns: ["Column 1", "Column 2", "Column 3"],
    data: ["Data 1", "Data 2", "Data 3"],
  },
  {
    value: "option2",
    label: "Fruits Seva",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
  {
    value: "option3",
    label: "Dry Fruits Seva",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
  {
    value: "option4",
    label: "Ghee Seva",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
  {
    value: "option5",
    label: "Milk Seva",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
  {
    value: "option6",
    label: "Vegetable Seva",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },

  // Add more options here
];

export const option1: DonationCategory[] = [
    {
      title: "Deity Seva for the Month",
      donations: [
        { id: 1, title: "Donate Rs 500 for Deity Seva this month", amount: 500 },
        { id: 2, title: "Donate Rs 1000 for Deity Seva this month", amount: 1000 },
        { id: 3, title: "Donate Rs 2000 for Deity Seva this month", amount: 2000 },
        { id: 4, title: "Donate Rs 3000 for Deity Seva this month", amount: 3000 },
        { id: 5, title: "Donate Rs 5000 for Deity Seva this month", amount: 5000 },
      ],
    },
  ];
  
  

  export const option2: DonationCategory[] = [
    {
      title: "Fruits Seva for the Month",
      donations: [
        { id: 1, title: "Donate Rs 500 for Fruits Seva this month", amount: 500 },
        { id: 2, title: "Donate Rs 1000 for Fruits Seva this month", amount: 1000 },
        { id: 3, title: "Donate Rs 2000 for Fruits Seva this month", amount: 2000 },
        { id: 4, title: "Donate Rs 3000 for Fruits Seva this month", amount: 3000 },
        { id: 5, title: "Donate Rs 5000 for Fruits Seva this month", amount: 5000 },
      ],
    },
  ];
  

  export const option3: DonationCategory[] = [
    {
      title: "Dry Fruits Seva for the Month",
      donations: [
        { id: 1, title: "Donate Rs 500 for Dry Fruits Seva this month", amount: 500 },
        { id: 2, title: "Donate Rs 1000 for Dry Fruits Seva this month", amount: 1000 },
        { id: 3, title: "Donate Rs 2000 for Dry Fruits Seva this month", amount: 2000 },
        { id: 4, title: "Donate Rs 3000 for Dry Fruits Seva this month", amount: 3000 },
        { id: 5, title: "Donate Rs 5000 for Dry Fruits Seva this month", amount: 5000 },
      ],
    },
  ];
  
      

  export const option4: DonationCategory[] = [
    {
      title: "Ghee Seva for the Month",
      donations: [
        { id: 1, title: "Donate Rs 500 for Ghee Seva this month", amount: 500 },
        { id: 2, title: "Donate Rs 1000 for Ghee Seva this month", amount: 1000 },
        { id: 3, title: "Donate Rs 2000 for Ghee Seva this month", amount: 2000 },
        { id: 4, title: "Donate Rs 3000 for Ghee Seva this month", amount: 3000 },
        { id: 5, title: "Donate Rs 5000 for Ghee Seva this month", amount: 5000 },
      ],
    },
  ];
  
  export const option5: DonationCategory[] = [
    {
      title: "Milk Seva for the Month",
      donations: [
        { id: 1, title: "Donate Rs 500 for Milk Seva this month", amount: 500 },
        { id: 2, title: "Donate Rs 1000 for Milk Seva this month", amount: 1000 },
        { id: 3, title: "Donate Rs 2000 for Milk Seva this month", amount: 2000 },
        { id: 4, title: "Donate Rs 3000 for Milk Seva this month", amount: 3000 },
        { id: 5, title: "Donate Rs 5000 for Milk Seva this month", amount: 5000 },
      ],
    },
  ];
  
  export const option6: DonationCategory[] = [
    {
      title: "Vegetable Seva for the Month",
      donations: [
        { id: 1, title: "Donate Rs 500 for Vegetable Seva this month", amount: 500 },
        { id: 2, title: "Donate Rs 1000 for Vegetable Seva this month", amount: 1000 },
        { id: 3, title: "Donate Rs 2000 for Vegetable Seva this month", amount: 2000 },
        { id: 4, title: "Donate Rs 3000 for Vegetable Seva this month", amount: 3000 },
        { id: 5, title: "Donate Rs 5000 for Vegetable Seva this month", amount: 5000 },
      ],
    },
  ];
  